import { connect } from 'react-redux';
import Guides from './guides';

const mapStateToProps = ({ canvas }) => canvas;

export default connect(mapStateToProps)(Guides);
